<template>
 <div id="page">
    <div id="cards" class="row flex">
        <sp-card :valor="pessoasEmSituacaoDeRua" :descricao="$t('assistencia.censo.totalOcupantes')" stripe=""/>
        <sp-card :valor="mediaIdadeGeral" :descricao="$t('assistencia.censo.idadeMedia')" sufix=" anos" stripe=""/>
        <!--
        <sp-card :valor="mediaIdadeHomem" :descricao="$t('assistencia.censo.idadeHomens')" sufix=" anos" stripe=""/>
        <sp-card :valor="mediaIdadeMulheres" :descricao="$t('assistencia.censo.idadeMulheres')" sufix=" anos" stripe=""/>
        <sp-card :valor="totalCriancas" :descricao="$t('assistencia.censo.crianca')" stripe=""/>
        <sp-card :valor="totalOcupantes" :descricao="$t('assistencia.censo.totalOcupantes')" stripe=""/>
        -->
    </div>
    <div id="painelTopo" class="row">
        <div class="flex md12 sm12">
            <sp-360-panel :title="$t('assistencia.censo.painelTopo.titulo')" :footerText="footerHistograma" :footerComplementar="footerfonte">
                <sp-360-chart :data="idadeHistogramaChartData" :options="idadeHistogramaOptions" type="vertical-bar" class="chart-panel"/>
            </sp-360-panel>
        </div>
    </div>
    <div id="painelMeio" class="row">
        <div class="flex md6 sm12">
            <sp-360-panel :title="$t('assistencia.censo.painelMeio.tituloSexo')" :footerText="footerfonte">
                <sp-360-chart :data="sexoPieChartData" :options="sexoPieChartOptions" type="pie" class="chart-panel"/>
            </sp-360-panel>
        </div>
        <div class="flex md6 sm12">
            <sp-360-panel :title="$t('assistencia.censo.painelMeio.tituloGenero')" :footerText="footerfonte">
                <sp-360-chart :data="generoPieChartData" :options="generoPieChartOptions" type="horizontal-bar" class="chart-panel"/>
            </sp-360-panel>
        </div>
    </div>
    <div id="painelMeio" class="row">
        <div class="flex md12 sm12">
            <sp-360-panel :title="$t('assistencia.censo.painelMeio.tituloDistrito')" id="painelSup" :footerText="footerfonte" >
                <div class="flex-box">
                  <div class="row">
                      <va-button-toggle
                        id="toggle-button"
                        outline small
                        v-model="seletorEstado"
                        :options="toggleButtonOptionsCasos"
                        color="info"
                        @input="onToggleChangeEstado"
                        />
                  </div>
                  <br>
                  <div class="row">
                      <sp-distritos v-on:regiaoClicada="filtrarPorRegiao($event)" ref="dist" id="mapaSP"
                          :habilitarAnimacaoClique="false" v-show="!showTableOrgao"/>
                      <sp360-data-table id="tabelaServicosPorOrgao" ref="tabelaServicosPorOrgao"  v-show="!showTableOrgao" :apiMode="false"
                          :data="tabela.data" :fields="tabela.tableFields"
                          :sortFunctions="tabela.sortFunctions" :perPage="tabela.itemsPerPage" />
                  </div>
                </div>
            </sp-360-panel>
        </div>
    </div>
    <div id="painelFundo" class="row">
        <div class="flex md6 sm12">
            <sp-360-panel :title="$t('assistencia.censo.painelFundo.tituloRacaEtnia')" :footerText="footerEtnia" :footerComplementar="footerfonte">
                <sp-360-chart :data="racaEtniaChartData" :options="racaEtniaChartOptions" type="horizontal-bar" class="chart-panel"/>
            </sp-360-panel>
        </div>
        <div class="flex md6 sm12">
            <sp-360-panel :title="$t('assistencia.censo.painelFundo.tituloTempoRua')" :footerText="$t('assistencia.censo.nrns')" :footerComplementar="footerfonte">
                <sp-360-chart :data="tempoRuaPieChartData" :options="tempoRuaPieChartOptions" type="donut" class="chart-panel"/>
            </sp-360-panel>
        </div>
    </div>
    <div id="painelmapa" class="row">
      <div class="flex md12 sm12">
        <sp-360-panel :title="$t('assistencia.censo.painelMapa.titulo')" :footerText="footerfonte" >
             <GmapMap
                    id="mapaCenso"
                    ref="gmap"
                    :center="this.center"
                    :zoom="this.zoom"
                    map-type-id="roadmap"
                    style="width: 100%; height: 45rem">
              </GmapMap>
        </sp-360-panel>
      </div>
    </div>
 </div>
</template>

<script>
import * as d3 from 'd3'
import _ from 'lodash'
import MetodosGlobais from '@/utils/MetodosGlobais'
import CorUtils from '@/utils/CorUtils'
import Multiselect from 'vue-multiselect'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import SpMap from '@/components/maps/360-maps/SPMap.vue'
import SPMapaNomes from '@/utils/SPMapaNomes'
import SpDistritos from '@/components/maps/360-maps/SPDistritos'
import SPDistritosNomes from '@/utils/SPDistritosNomes'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360datatable from '../../ui/dataTable/sp360datatable.vue'
import SpCard from '@/components/ui/cards/SP360Card'
import CensoPopulacaoDeRuaHelper from '@/utils/CensoPopulacaoDeRuaHelper'
import Overlay from '@/assets/geojson/spoverlay'
import { gmapApi } from 'vue2-google-maps'
import constantes from '@/utils/ConstantesGlobais'

export default {
  name: 'censo-populacao-de-rua',
  mixins: [Overlay],
  components: {
    SpMap,
    Multiselect,
    Sp360DataTable,
    Sp360Panel,
    SpDistritos,
    SPDistritosNomes,
    Sp360Chart,
    SpCard,
    SPMapaNomes,
    Sp360datatable,
    CensoPopulacaoDeRuaHelper,
    gmapApi,
  },

  props: {

  },

  data () {
    return {
      fonte: 'SMADS',
      data: '2021',

      toggleButtonOptionsCasos: [
        { label: 'Na rua', value: 0 },
        { label: 'Acolhido', value: 1 },
      ],

      seletorEstado: 0,

      // gmap
      center: constantes.PARAMETROS_DASHBOARD.MOBILIDADE.GMAP_CENTER,
      zoom: constantes.PARAMETROS_DASHBOARD.MOBILIDADE.GMAP_ZOOM,
      heatMapData: [],
      // mapa
      subSel: null,
      tabela: {
        data: [],
        tableFields: [{
          name: 'nome',
          sortField: 'nome',
          title: this.$t('assistencia.censo.tabela.subprefeitura'),
          width: '50%',
        }, {
          name: 'total_situacao_rua',
          sortField: 'total_situacao_rua',
          title: this.$t('assistencia.censo.tabela.total'),
          width: '50%',
          callback: (value) => {
            return value.toLocaleString('pt-BR')
          },
        }],
        tableFieldsOrgao: [],
        tableFieldsSub: [],
        itemsPerPage: 10,
      },

      showTableOrgao: 0,
      showTableOrgaoOptions: [{ atributo: 0, label: 'Distrito' }, { atributo: 1, label: 'Subprefeitura' }],
      corteTemporalEscolhido: this.$t('mainDashboard.multiselect.ultimos30Dias'),

      resposta: {},
      helper: CensoPopulacaoDeRuaHelper,
      objeto: {
        Classificacao_de_idade: '',
        Cor_Raca_Etnia: '',
        Crianca_Sozinha: '',
        Crianca_acomp_Adulto: '',
        Data: '',
        Distrito: '',
        Faixa_de_idade: '',
        ID: 0,
        Idade: '',
        Identifica_com_o_sexo_nasceu: '',
        Latitude: 0,
        Longitude: 0,
        Onde_dormiu_ontem: '',
        Parentes_no_CA: '',
        Presenca_Moradia_Improvisada: '',
        Sexo: '',
        Situacao_de_rua: '',
        Subprefeitura: '',
        Tempo_de_permanência: '',
        Tempo_na_situacao: '',
        Tipo_de_ponto: '',
      },

      // cards
      mediaIdadeGeral: 0,
      mediaIdadeMulheres: 0,
      mediaIdadeHomem: 0,

      pessoasEmSituacaoDeRua: 0,

      totalOcupantes: 0,
      totalCriancas: 0,
      menoresDeIdade: 0,
      criancaSozinha: 0,
      naoRespondeuEtnia: 0,

      // ---
      ruaDistrito: [],
      acolhidosDistrito: [],
      ruaSubprefeitura: [],
      acolhidosSubprefeitura: [],

      // maps
      distritos: _.orderBy(SPDistritosNomes, 'nome'),
      subprefeituras: _.orderBy(SPMapaNomes.slice(1), 'nome'),
      percMapa: 0,
      totalMapa: 0,

      // graficos
      idadeHistogramaChartData: {},
      idadeHistogramaOptions: {
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 45,
            bottom: 5,
          },
        },
        plugins: {
          datalabels: {},
        },
        scales: {
          yAxes: [{
            categoryPercentage: 0.2,
            barPercentage: 1.0,
            type: 'linear',

            scaleLabel: {
              display: true,
              labelString: 'Número de Pessoas',
            },
            ticks: {
              beginAtZero: true,
              autoSkip: true,
              maxTicksLimit: 15,
              callback: function (value, index, values) {
                if (!isNaN(value)) {
                  return MetodosGlobais.formatarGrandesNumeros(value)
                } else {
                  return value
                }
              },
            },
          }],
          xAxes: [
            {
              position: 'left',
              gridLines: {
                display: false,
              },
              scaleLabel: {
                display: true,
                labelString: 'Idades',
              },
              ticks: {
                callback: function (value, index, values) {
                  return value
                },
              },
            },
          ],
        },
        tooltips: {
          mode: 'index',
          enabled: true,
          intersect: false,
          position: 'nearest',
          callbacks: {
            label: (tooltipItem, chart) => {
              let label = chart.datasets[0].label
              label += ': ' + tooltipItem.yLabel.toLocaleString('pt-BR')
              return label
            },
          },
        },
        legend: { display: false },
      },
      sexoPieChartOptions: {
        plugins: {
          datalabels: {},
        },
        legend: {
          position: 'left',
          labels: {
            usePointStyle: 'true',
          },
        },
        tooltips: {
          mode: 'index',
          enabled: true,
          intersect: false,
          position: 'nearest',
          callbacks: {
            label: (tooltipItem, chart) => {
              let label = chart.datasets[tooltipItem.datasetIndex].labels[tooltipItem.index]
              label += ': ' + chart.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR')
              return label
            },
          },
        },
      },
      sexoPieChartData: {},

      racaEtniaChartData: {},
      racaEtniaChartOptions: {
        plugins: {
          datalabels: {},
        },
        legend: { display: false },
        tooltips: {
          mode: 'index',
          enabled: true,
          intersect: false,
          position: 'nearest',
          callbacks: {
            label: (tooltipItem, chart) => {
              return `${tooltipItem.yLabel.toLocaleString('pt-BR')} : ${tooltipItem.xLabel.toLocaleString('pt-BR')} `
            },
          },
        },
      },

      generoPieChartData: {},
      generoPieChartOptions: {
        plugins: {
          datalabels: {},
        },
        legend: { display: false },
        tooltips: {
          mode: 'index',
          enabled: true,
          intersect: false,
          position: 'nearest',
          callbacks: {
            label: (tooltipItem, chart) => {
              console.log(tooltipItem)
              let label = 'Total: '
              label += tooltipItem.xLabel.toLocaleString('pt-BR')
              return label
            },
          },
        },
      },
      tempoRuaPieChartData: {},
      tempoRuaPieChartOptions: {
        plugins: {
          datalabels: {},
        },
        tooltips: {
          mode: 'index',
          enabled: true,
          intersect: false,
          position: 'nearest',
          callbacks: {
            label: (tooltipItem, chart) => {
              let label = chart.datasets[tooltipItem.datasetIndex].labels[tooltipItem.index]
              label += ': ' + chart.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toLocaleString('pt-BR')
              return label
            },
          },
        },
      },

      arrayIdades: [],
      naoRespondeuIdade: 0,
      semIdentificacao: {},
    }
  },

  computed: {
    google: gmapApi,

    footerHistograma () {
      return `Das ${(this.pessoasEmSituacaoDeRua || 0).toLocaleString('pt-BR')} pessoas entrevistadas, ${(this.naoRespondeuIdade || 0).toLocaleString('pt-BR')} (${(this.naoRespondeuIdade / this.pessoasEmSituacaoDeRua).toLocaleString('pt-BR', { style: 'percent' }) || 0}) não responderam suas idades. `
    },
    footerPieGenero () {
      let cisgenero = this.cisgeneroHomem + this.cisgeneroMulher
      let percCis = cisgenero / this.pessoasEmSituacaoDeRua
      let percNR = (this.naoRespondeuGenero / this.pessoasEmSituacaoDeRua)

      return this.$t('assistencia.censo.genero', {
        totalCisgenero: cisgenero.toLocaleString('pt-BR'),
        percentualCisgenero: percCis.toLocaleString('pt-BR', { style: 'percent' }),
        totalSemIdentificacao: this.naoRespondeuGenero.toLocaleString('pt-BR'),
        percentualSemIdentificacao: percNR.toLocaleString('pt-BR', { style: 'percent' }),
      })
    },
    footerEtnia () {
      let naoIdentificados = (this.naoRespondeuEtnia.total_situacao_rua + this.semIdentificacao.total_situacao_rua)
      return this.$t('assistencia.censo.racaEtnia', { total: naoIdentificados.toLocaleString('pt-BR'), percentual: (naoIdentificados / this.pessoasEmSituacaoDeRua).toLocaleString('pt-BR', { style: 'percent' }) })
    },

    footerfonte () {
      return this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })
    },
  },

  created () {
    Promise.all([
      this.$store.dispatch('assistenciaSocial/censoPopulacaoDeRua'),
      this.$gmapApiPromiseLazy(),
      this.$store.dispatch('assistenciaSocial/censoDeRuaSituacaoConsolidado'),
      this.$store.dispatch('assistenciaSocial/censoDeRuaSituacaoPorAgrupamento', { agrupamentoGeral: 'sexo' }),
      this.$store.dispatch('assistenciaSocial/censoDeRuaSituacaoPorAgrupamento', { agrupamentoGeral: 'FAIXA_IDADE' }),
      this.$store.dispatch('assistenciaSocial/censoDeRuaSituacaoPorAgrupamento', { agrupamentoGeral: 'CLASSIFICACAO_IDADE' }),
      this.$store.dispatch('assistenciaSocial/censoDeRuaSituacaoConsolidadoPorIntervaloIdade', {}),
      this.$store.dispatch('assistenciaSocial/censoDeRuaSituacaoDetalhado'),
      this.$store.dispatch('assistenciaSocial/censoDeRuaSituacaoPorAgrupamento', { agrupamentoGeral: 'IDENTIDADE_SEXUAL' }),
      this.$store.dispatch('assistenciaSocial/censoDeRuaSituacaoPorAgrupamento', { agrupamentoGeral: 'COR_RACA_ETNIA' }),
      this.$store.dispatch('assistenciaSocial/censoDeRuaSituacaoPorAgrupamento', { agrupamentoGeral: 'TEMPO_RUA' }), // 10
      this.$store.dispatch('assistenciaSocial/censoDeRuaSituacaoPorAgrupamento', { agrupamentoRegiao: 'SUBPREFEITURA' }),
      this.$store.dispatch('assistenciaSocial/censoDeRuaSituacaoPorAgrupamento', { agrupamentoRegiao: 'DISTRITO' }),

    ]).then(resposta => {
      this.res = resposta
      this.fonte = this.res[2].data.fonte
      this.dataRef = new Date(this.res[2].data.data_referencia_dado).toLocaleDateString('pt-BR', { timeZone: 'UTC' })

      this.consolidados = resposta[2].data.data[0]
      this.pessoasPorSexo = resposta[3].data.data
      this.pessoasPorIdade = resposta[4].data.data
      this.detalhado = resposta[7].data.data
      this.pessoasPorIdentidadeGenero = resposta[8].data.data
      this.pessoasPorRacaCorEtnia = resposta[9].data.data
      this.pessoasPorTempoRua = resposta[10].data.data

      this.pessoasEmSituacaoDeRua = this.consolidados.total_situacao_rua
      this.mediaIdadeGeral = this.consolidados.media_idade
      this.map = resposta[1]

      this.distritosD = _.orderBy(resposta[12].data.data, 'distrito', ['asc']) || []
      this.distritosD.forEach(e => {
        if (e.situacao === 'Rua') { this.ruaDistrito.push(e) } else if (e.situacao === 'Acolhido') { this.acolhidosDistrito.push(e) }
      })

      this.subprefeiturasD = _.orderBy(resposta[11].data.data, 'total_situacao_rua', ['desc']) || []
      this.subprefeiturasD.forEach(e => {
        if (e.situacao === 'Rua') { this.ruaSubprefeitura.push(e) } else if (e.situacao === 'Acolhido') { this.acolhidosSubprefeitura.push(e) }
      })

      let somaIdadeHomem = 0
      let somaIdadeMulher = 0
      let countHomem = 0
      let countMulher = 0

      // Google maps
      this.detalhado.forEach(el => {
        if (el.latitude && el.longitude) {
          this.heatMapData.push({
            location: new google.maps.LatLng(parseFloat(el.latitude), parseFloat(el.longitude)),
            weight: 1,
            sub: el.Subprefeitura,
          })
        }
      })

      this.mediaIdadeHomem = (somaIdadeHomem / countHomem).toLocaleString('pt-BR', { maximumFractionDigits: 1 })
      this.mediaIdadeMulheres = (somaIdadeMulher / countMulher).toLocaleString('pt-BR', { maximumFractionDigits: 1 })

      this.montarGraficoFaixaEtaria(this.pessoasPorIdade)
      this.racaEtniaChartData = this.montarGraficoEtnia(this.pessoasPorRacaCorEtnia)

      this.idadeHistogramaChartData = this.montarGraficoIdadeHistrograma(this.pessoasPorIdade)
      this.sexoPieChartData = this.montarGraficoSexo(this.pessoasPorSexo)

      this.generoPieChartData = this.montarGraficoGenero(this.pessoasPorIdentidadeGenero)

      this.tempoRuaPieChartData = this.montarGraficoTempoRua(this.pessoasPorTempoRua)

      this.tabchange()
      this.iniciarGmap()
    })
  },

  methods: {
    mapReduce (map, key) {
      map.set(
        key, this.converteESoma(map.get(key), 1)
      )
    },

    converteESoma (value, increment) {
      let x = parseInt(value)
      return x + increment
    },

    mapAdd (map, el) {
      (map.get(el)) ? this.mapReduce(map, el) : (map.set(el, 1))
    },

    arrayAdd (map, el) {
      if (el.toLowerCase() === 'não respondeu') {
        this.naoRespondeuIdade += 1
      } else {
        let index = _.findIndex(map, (o) => { return o.key === parseInt(el) })
        if (index > -1) {
          map[index].value += 1
        } else {
          map.push({ key: parseInt(el), value: 1 })
        }
      }
    },

    sumarizador (arr, el, atr = 'total') {
      let x = arr.findIndex(e => {
        return e.nome.toLowerCase() === MetodosGlobais.replaceSpecialChars(el).toLowerCase()
      })
      if (x === -1) {
        console.error('ERRO: ' + el + ' Não é um Distrito/Subprefeitura')
      } else {
        arr[x].total += 1
      }
    },

    replaceSpecialChars (str) {
      str = str.replace(/[ÀÁÂÃÄÅ]/, 'A')
      str = str.replace(/[àáâãäå]/, 'a')
      str = str.replace(/[ÈÉÊË]/, 'E')
      str = str.replace(/[èéêë]/, 'e')
      str = str.replace(/[ÌÍÎÏ]/, 'I')
      str = str.replace(/[ìíîï]/, 'i')
      str = str.replace(/[ÒÓÕÔÖ]/, 'O')
      str = str.replace(/[òóôõö]/, 'o')
      str = str.replace(/[ÙÚÜ]/, 'U')
      str = str.replace(/[ùúü]/, 'u')
      str = str.replace(/[Ç]/, 'C')
      str = str.replace(/[ç]/, 'c')
      return str
    },

    montarGraficoFaixaEtaria (dados) {
    },

    montarGraficoPorDistrito (dados) {
    },

    montarGraficoSexo (dados) {
      let initialValue = 0
      let labels = []
      let dataset = {
        backgroundColor: CorUtils.getVetorCoresPorTom('medio'),
        borderColor: this.$store.getters.palette.transparent,
        data: [],
        labels: [],
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => MetodosGlobais.formatarGrandesNumeros(value) + '\n' + (value / dataset.metadata).toLocaleString('pt-BR', { style: 'percent' }),
          anchor: 'middle',
          rotation: 0,
          align: 'end',
          display: 'true',
          font: {
            size: 13,
            weight: 'bold',
          },
        },
      }
      dataset.data = []

      dados.forEach(e => {
        dataset.data.push(e.total_situacao_rua)
        dataset.labels.push(e.sexo)
        labels.push(e.sexo)
      })
      dataset.metadata = dataset.data.reduce((a, b) => { return a + b }, initialValue)
      return { datasets: [dataset], labels: labels }
    },

    montarGraficoGenero (dados) {
      let labels = []
      let dataset = {
        backgroundColor: CorUtils.getVetorCoresPorTom('medio'),
        borderColor: this.$store.getters.palette.transparent,
        data: [],
        labels: [],
        legend: {
          display: false,
        },
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => MetodosGlobais.formatarGrandesNumeros(value) + '\n' + (value / this.pessoasEmSituacaoDeRua).toLocaleString('pt-BR', { minimumFractionDigits: 2, style: 'percent' }),
          anchor: 'end',
          rotation: 0,
          align: 'middle',
          display: 'true',
          font: {
            size: 13,
            weight: 'bold',
          },
        },
      }

      dados = _.orderBy(dados, ['total_situacao_rua'], ['asc'])

      this.cisgeneroHomem = dados[_.findIndex(dados, { 'identidade_sexual': 'Homem Cisgênero' })]
      this.naoRespondeuGenero = dados[_.findIndex(dados, { 'identidade_sexual': 'Não respondeu' })]
      this.cisgeneroMulher = dados[_.findIndex(dados, { 'identidade_sexual': 'Mulher Cisgênero' })]

      _.remove(dados, function (n) {
        return n.identidade_sexual === 'Homem Cisgênero' || n.identidade_sexual === 'Não respondeu' || n.identidade_sexual === 'Mulher Cisgênero'
      })

      dados.forEach(e => {
        dataset.data.push(e.total_situacao_rua)
        dataset.labels.push(e.identidade_sexual)
        labels.push(e.identidade_sexual)
      })

      return { datasets: [dataset], labels: labels }
    },

    montarGraficoEtnia (dados) {
      let labels = []
      let dataset = {
        backgroundColor: CorUtils.getVetorCoresPorTom('medio'),
        borderColor: this.$store.getters.palette.transparent,
        data: [],
        labels: [],
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => MetodosGlobais.formatarGrandesNumeros(value) + '\n' + (value / this.pessoasEmSituacaoDeRua).toLocaleString('pt-BR', { style: 'percent' }),
          anchor: 'middle',
          rotation: 0,
          align: 'end',
          display: 'true',
          font: {
            size: 12,
            weight: 'bold',
          },
        },
      }

      this.naoRespondeuEtnia = dados[_.findIndex(dados, { 'cor_raca_etnia': 'Não respondeu' })]
      this.semIdentificacao = dados[_.findIndex(dados, { 'cor_raca_etnia': 'Sem identificação' })]

      _.remove(dados, function (n) {
        return n.cor_raca_etnia === 'Sem identificação' || n.cor_raca_etnia === 'Não respondeu'
      })

      dados.forEach(e => {
        dataset.data.push(e.total_situacao_rua)
        dataset.labels.push(e.cor_raca_etnia)
        labels.push(e.cor_raca_etnia)
      })

      return { datasets: [dataset], labels: labels }
    },

    montarGraficoTempoRua (dados) {
      let initialValue = 0
      let labels = []
      let dataset = {
        backgroundColor: CorUtils.getVetorCoresPorTom('medio'),
        borderColor: this.$store.getters.palette.transparent,
        data: [],
        labels: [],
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => MetodosGlobais.formatarGrandesNumeros(value) + '\n' + (value / this.pessoasEmSituacaoDeRua).toLocaleString('pt-BR', { style: 'percent' }),
          anchor: 'middle',
          rotation: 0,
          align: 'end',
          display: 'true',
          font: {
            size: 12,
            weight: 'bold',
          },
        },
      }

      this.naoRespondeuTempoRua = dados[_.findIndex(dados, { 'tempo_na_rua': 'Não respondeu' })]
      this.semIdentificacaoTempoRua = dados[_.findIndex(dados, { 'tempo_na_rua': 'Sem identificação' })]

      _.remove(dados, function (n) {
        return n.tempo_na_rua === 'Sem identificação' || n.tempo_na_rua === 'Não respondeu'
      })

      dados.forEach(e => {
        dataset.data.push(e.total_situacao_rua)
        dataset.labels.push(e.tempo_na_rua)
        labels.push(e.tempo_na_rua)
      })

      return { datasets: [dataset], labels: labels }
    },

    montarGraficoIdadeHistrograma (map) {
      let dataset = {
        data: [],
        label: 'Pessoas em situação de rua',
        backgroundColor: 'red',
        datalabels: {
          color: CorUtils.getCorPorNomeSp360('preto-escuro'),
          formatter: (value) => MetodosGlobais.formatarGrandesNumeros(value) + '\n' + (value / this.pessoasEmSituacaoDeRua).toLocaleString('pt-BR', { style: 'percent', maximumFractionDigits: 2 }),
          anchor: 'end',
          rotation: 0,
          align: 'end',
          display: 'true',
          font: {
            size: 11,
            weight: 'bold',
          },
        },
        layout: {
          padding: {
            top: 50,
          },
        },
      }
      let labels = []

      let classificacao = [{
        index: 0,
        faixa_idade: 'Até 11',
        total_situacao_rua: 0,
      }, {
        index: 1,
        faixa_idade: '12 a 17',
        total_situacao_rua: 0,
      }, {
        index: 2,
        faixa_idade: '18 a 30',
        total_situacao_rua: 0,
      }, {
        index: 3,
        faixa_idade: '31 a 49',
        total_situacao_rua: 0,
      }, {
        index: 4,
        faixa_idade: '50 a 59',
        total_situacao_rua: 0,
      }, {
        index: 5,
        faixa_idade: '60 a 69',
        total_situacao_rua: 0,
      }, {
        index: 6,
        faixa_idade: '70 a 79',
        total_situacao_rua: 0,
      }, {
        index: 7,
        faixa_idade: '80 a 89',
        total_situacao_rua: 0,
      }, {
        index: 8,
        faixa_idade: '90 a 99',
        total_situacao_rua: 0,
      }]

      while (map.length > 0) {
        let x = map.pop()

        classificacao.forEach(element => {
          if (x.faixa_idade === element.faixa_idade) {
            element.total_situacao_rua = x.total_situacao_rua
          } else if (x.faixa_idade === 'Sem informação') {
            this.naoRespondeuIdade = x.total_situacao_rua
          }
        })
      }

      classificacao.forEach(e => {
        labels.push(e.faixa_idade)
        dataset.data.push(e.total_situacao_rua)
      })

      return { datasets: [dataset], labels: labels }
    },

    comparador (a, b) {
      let x = parseInt(a)
      let y = parseInt(b)

      let xb = isNaN(x)
      let yb = isNaN(y)
      if (xb && yb) {
        if (a > b) return 1
        if (a < b) return -1
        return 0
      }
      if (xb) {
        return y
      }
      if (yb) {
        return x
      }

      return a - b
    },
    // ChartOptions
    getPieChartOptions () {
      return {
        plugins: {
          datalabels: {},
        },
      }
    },
    // Mapa
    pintarMapa (data, prop, elemento, legenda) {
      let mapaCores = {
        claro: 'lightblue',
        medio: 'blue',
        escuro: 'red',
      }
      let dados = _.orderBy(data, [prop], 'asc')

      let first = _.first(dados)[prop]
      let last = _.last(dados)[prop]

      let colorScale = d3.scaleLinear()
        .domain([0, 0.1, 0.5, 1])
        .range(['#fff', mapaCores.claro, mapaCores.medio, mapaCores.escuro])

      dados.forEach(o => {
        if (o.id) {
          let norm = (o[prop] - first) / (last - first)
          norm = (norm < 0.2) ? norm : norm + 0.6
          this.$refs[elemento].pintarRegiao(o.id, colorScale(norm))
          this.$refs[elemento].setLegenda(first, last, legenda, 5)
          this.$refs[elemento].definirLegenda(['#fff', mapaCores.claro, mapaCores.medio, mapaCores.escuro], [this.$t('mainDashboard.legendaTitulo'), this.$t('mainDashboard.legendaBaixa'), this.$t('mainDashboard.legendaMedia'), this.$t('mainDashboard.legendaAlta')])
        }
      })
    },

    tabClick () {
      this.tabchange()
    },

    onToggleChangeEstado () {
      this.tabchange()
    },

    tabchange () {
      if (this.showTableOrgao) {
        for (let index = 0; index < this.subprefeituras.length; index++) {
          if (this.seletorEstado) {
            this.subprefeituras[index].total_situacao_rua = (this.acolhidosSubprefeitura[index] ? this.acolhidosSubprefeitura[index] : 0)
          } else {
            this.subprefeituras[index].total_situacao_rua = (this.ruaSubprefeitura[index] ? this.ruaSubprefeitura[index] : 0)
          }
        }
        this.tabela.data = _.orderBy(this.subprefeituras, 'total_situacao_rua', ['desc']) || []
        this.pintarMapa(this.subprefeituras, 'total_situacao_rua', 'mapa', 'Pessoas em situação de Rua')
      } else {
        for (let index = 0; index < this.distritos.length; index++) {
          if (this.seletorEstado) {
            this.distritos[index].total_situacao_rua = this.acolhidosDistrito[index] ? this.acolhidosDistrito[index].total_situacao_rua : 0
          } else {
            this.distritos[index].total_situacao_rua = this.ruaDistrito[index] ? this.ruaDistrito[index].total_situacao_rua : 0
          }
        }
        this.tabela.data = _.orderBy(this.distritos, 'total_situacao_rua', ['desc']) || []
        this.pintarMapa(this.distritos, 'total_situacao_rua', 'dist', 'Pessoas em situação de Rua')
      }
    },

    buscaAtribui (target = [], source = [], prop, sumirize = false) {
      for (let index = 0; index < target.length; index++) {
        target[index].prop = source[index] ? this.ruaDistrito[index].total_situacao_rua : 0
      }
    },

    // gmap
    iniciarGmap () {
      this.$refs.gmap.$mapPromise.then((map) => {
        map.data.addGeoJson(this.getGeoJsonLayer())
        map.data.setStyle({ strokeWeight: 0 })
        let heatmap = new this.google.maps.visualization.HeatmapLayer({ data: this.heatMapData })
        heatmap.setMap(map)
      })
    },

    // Monta e retorna um objeto chartData com um dataset
    // @parametros
    // dataset - objeto com as definições do chartjs dataset
    // dados  - lista de ojetos de dados do grafico | para melhor apresentação passe um vetor ordenado para o metodo
    // dataProp  - dimensao
    // labelProp - medida
    // @return
    // chartData
    montarGrafico (dataset, dados, dataprop, labelprop) {
      let check = _.first(dados)
      let labels = []
      if (check.hasOwnProperty(dataprop) && check.hasOwnProperty(labelprop)) {
        dados.forEach(e => {
          labels.push(e[labelprop])
          dataset.data.push(e[dataprop])
        })
        return { datasets: [dataset], labels: labels }
      } else {
        check.hasOwnProperty(dataprop) ? console.error(dataprop + 'não existem em elementos da lista') : ''
        check.hasOwnProperty(dataprop) ? console.error(labelprop + 'não existem em elementos da lista') : ''
        return { datasets: [dataset], labels: labels }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .chart-panel{
      max-height: 30rem;
  }
  #mapaSP{
      width: 35%;
      height: 30em;
  }
  #tabelaServicos{
      width: 65%;
      height: 20rem;
  }
  #tabelaServicosPorOrgao{
      width: 65%;
  }
  #mapaCenso{
    width: 100%;
  }
</style>
